var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "ptvReleaseModal",
        "content-class": "release-modal",
        size: "lg",
        "hide-footer": "",
        "hide-header-close": "",
        "no-close-on-backdrop": "",
        centered: "",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "rm-header d-flex align-items-center w-100" },
                [
                  _c("div", { staticClass: "rm-header-icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: {
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "#4db8ff",
                            "stroke-width": "1.5",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2z",
                            stroke: "#4db8ff",
                            "stroke-width": "1.5",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M4.93 4.93a16 16 0 0 1 14.14 0M4.93 19.07a16 16 0 0 0 14.14 0",
                            stroke: "#4db8ff",
                            "stroke-width": "1.5",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "rm-header-text" }, [
                    _c("h5", { staticClass: "rm-title mb-0" }, [
                      _vm._v("Select a Region"),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "rm-subtitle mb-0" }, [
                      _vm._v("Choose a dataset to explore on the map"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "rm-header-badge ml-auto" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.releases.length) +
                        " region" +
                        _vm._s(_vm.releases.length !== 1 ? "s" : "") +
                        " available\n      "
                    ),
                  ]),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "rm-body", attrs: { fluid: "" } },
        [
          _vm.releases.length === 0
            ? _c(
                "b-row",
                { staticClass: "justify-content-center" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "text-center rm-empty",
                      attrs: { cols: "12" },
                    },
                    [
                      _c("div", { staticClass: "rm-empty-icon" }, [
                        _vm._v("◎"),
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v("No regions available")]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "rm-grid" },
            _vm._l(_vm.releases, function (release, index) {
              return _c(
                "b-col",
                {
                  key: release.id,
                  staticClass: "rm-card-col mb-3",
                  attrs: { cols: "12", sm: "6" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "rm-card",
                      on: {
                        click: function ($event) {
                          return _vm.datasetSelected(release)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "rm-map-preview" }, [
                        _c("div", { staticClass: "rm-map-glow" }),
                        _vm._v(" "),
                        _vm.getRegionImage(release.extent_description)
                          ? _c("img", {
                              staticClass: "rm-map-img",
                              attrs: {
                                src: _vm.getRegionImage(
                                  release.extent_description
                                ),
                                alt: release.extent_description,
                              },
                            })
                          : _c("div", { staticClass: "rm-map-placeholder" }, [
                              _c(
                                "svg",
                                {
                                  staticClass: "rm-globe-fallback",
                                  attrs: {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("circle", {
                                    attrs: {
                                      cx: "12",
                                      cy: "12",
                                      r: "10",
                                      stroke: "#4db8ff",
                                      "stroke-width": "1.5",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2z",
                                      stroke: "#4db8ff",
                                      "stroke-width": "1.5",
                                    },
                                  }),
                                ]
                              ),
                            ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rm-card-info" }, [
                        _c("div", { staticClass: "rm-region-name" }, [
                          _vm._v(_vm._s(release.extent_description)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "rm-release-date" }, [
                          _c("span", { staticClass: "rm-date-dot" }),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formatDate(release.release_date)) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rm-card-action" }, [
                        _c("span", { staticClass: "rm-action-label" }, [
                          _vm._v("Select"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "rm-action-arrow",
                            attrs: { viewBox: "0 0 16 16", fill: "none" },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M3 8h10M9 4l4 4-4 4",
                                stroke: "currentColor",
                                "stroke-width": "1.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rm-card-shine" }),
                    ]
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }